{
  "AGENT_MGMT": {
    "HEADER": "Edustajat",
    "HEADER_BTN_TXT": "Lisää edustaja",
    "LOADING": "Haetaan Edustajalistaa",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Ylläpitäjä",
      "AGENT": "Edustajat"
    },
    "TABS": {
      "ACTIVE": "Aktiiviset",
      "DEACTIVATED": "Deaktivoidut"
    },
    "DISCONNECT_PHONE": {
      "BUTTON_TEXT": "Katkaise puhelinyhteys",
      "API": {
        "SUCCESS_MESSAGE": "Edustajan puhelinyhteys katkaistiin onnistuneesti",
        "ERROR_MESSAGE": "Edustajan puhelinyhteyttä ei voitu katkaista, yritä myöhemmin uudelleen"
      }
    },
    "REACTIVATE": {
      "BUTTON_TEXT": "Aktivoi uudelleen",
      "API": {
        "SUCCESS_MESSAGE": "Edustaja aktivoitiin uudelleen onnistuneesti",
        "ERROR_MESSAGE": "Edustajaa ei voitu aktivoida uudelleen, yritä myöhemmin uudelleen"
      },
      "CONFIRM": {
        "TITLE": "Vahvista uudelleenaktivointi",
        "MESSAGE": "Haluatko varmasti aktivoida uudelleen ",
        "YES": "Kyllä, aktivoi uudelleen ",
        "NO": "Ei, peruuta "
      }
    },
    "LIST": {
      "404": "Tälle tilille ei ole liitetty edustajia",
      "TITLE": "Hallitse edustajia tiimissäsi",
      "DESC": "Voit lisätä tai poistaa edustajia tiimissäsi.",
      "NAME": "Nimi",
      "EMAIL": "Sähköposti",
      "STATUS": "Tila",
      "ACTIONS": "Toiminnot",
      "VERIFIED": "Vahvistettu",
      "VERIFICATION_PENDING": "Vahvistus odottaa",
      "API_ALLOWED": "API käytössä",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "Lisää edustaja tiimiisi",
      "DESC": "Voit lisätä ihmisiä, jotka voivat vastata viesteihin saapuneet-kansiossa.",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "FORM": {
        "NAME": {
          "LABEL": "Edustajan nimi",
          "PLACEHOLDER": "Ole hyvä ja kirjoita edustajan nimi"
        },
        "AGENT_TYPE": {
          "LABEL": "Agent Type",
          "PLACEHOLDER": "Please select a type",
          "ERROR": "Agent type is required"
        },
        "EMAIL": {
          "LABEL": "Sähköpostiosoite",
          "PLACEHOLDER": "Ole hyvä ja kirjoita edustajan sähköpostiosoite"
        },
        "SUBMIT": "Lisää edustaja"
      },
      "API": {
        "SUCCESS_MESSAGE": "Edustaja lisätty onnistuneesti",
        "EXIST_MESSAGE": "Edustajan sähköposti on jo käytössä, kokeile toista sähköpostiosoitetta",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Poista",
      "API": {
        "SUCCESS_MESSAGE": "Edustaja poistettu onnistuneesti",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      },
      "CONFIRM": {
        "TITLE": "Vahvista poistaminen",
        "MESSAGE": "Oletko varma että haluat poistaa ",
        "DESCRIPTION": "Edustaja kirjataan välittömästi ulos, poistetaan kaikista tiimeistä ja saapuneet-kansioista, eikä hänellä ole enää pääsyä tähän tiliin.",
        "YES": "Kyllä, poista ",
        "NO": "Ei, säilytä "
      }
    },
    "EDIT": {
      "TITLE": "Muokkaa edustajaa",
      "FORM": {
        "NAME": {
          "LABEL": "Edustajan nimi",
          "PLACEHOLDER": "Ole hyvä ja kirjoita edustajan nimi"
        },
        "AGENT_TYPE": {
          "LABEL": "Rooli",
          "PLACEHOLDER": "Valitse rooli",
          "ERROR": "Rooli on pakollinen"
        },
        "EMAIL": {
          "LABEL": "Sähköpostiosoite",
          "PLACEHOLDER": "Ole hyvä ja kirjoita edustajan sähköpostiosoite"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Saatavuus",
          "PLACEHOLDER": "Please select an availability status",
          "ERROR": "Availability is required"
        },
        "API_ACCESS": {
          "LABEL": "Ota API-pääsy käyttöön",
          "HELP": "API-pääsy on oletuksena pois käytöstä. Käyttöön ottaminen mahdollistaa tämän edustajan henkilökohtaisen API-avaimen käytön kaikilla tileillä, joihin hän kuuluu. Tämä ei vaikuta hallintapaneeliin kirjautumiseen."
        },
        "SUBMIT": "Muokkaa edustajaa"
      },
      "BUTTON_TEXT": "Muokkaa",
      "CANCEL_BUTTON_TEXT": "Peruuta",
      "API": {
        "SUCCESS_MESSAGE": "Edustajaa muokattu onnistuneesti",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Nollaa Salasana",
        "ADMIN_SUCCESS_MESSAGE": "Edustajalle on lähetetty sähköposti, jossa on salasanan palautusohjeet",
        "SUCCESS_MESSAGE": "Edustajan salasanan nollaus onnistui",
        "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
      }
    },
    "SEARCH": {
      "NO_RESULTS": "No results found."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "None",
      "TITLE": {
        "AGENT": "Select agent",
        "TEAM": "Select team"
      },
      "LIST": {
        "NONE": "None"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Edustajia ei löytynyt",
          "TEAM": "No teams found"
        },
        "PLACEHOLDER": {
          "AGENT": "Search agents",
          "TEAM": "Search teams",
          "INPUT": "Search for agents"
        }
      }
    }
  }
}
